import { get } from "svelte/store";
import { isFunction } from "./utils";
import axios from "./axios";
import { isCurrentUserLoaded, currentUserStore, setUserInfo, } from "../store/store-user";
import { axiosCall } from "./common";
export async function getUserSecrets(config = {}) {
    const requestConfig = { url: '/users/current/getUserSecrets', method: 'get' };
    try {
        const res = await axios(requestConfig);
        if (isFunction(config.onSuccess))
            await config.onSuccess(res.data);
        return res.data;
    }
    catch (error) {
        if (isFunction(config.onError))
            await config.onError(error);
    }
}
export async function getUser(config = {}) {
    const requestConfig = { url: '/users/current', method: 'get' };
    try {
        const res = await axios(requestConfig);
        if (isFunction(config.onSuccess))
            await config.onSuccess(res.data);
        // console.log("User Information: ", res.data);
        return res.data;
    }
    catch (error) {
        if (isFunction(config.onError))
            await config.onError(error);
    }
}
export async function sendDemoEmail(data, config = {}) {
    const requestConfig = { url: '/users/current/sendDemoEmail', method: 'post', data };
    try {
        const res = await axios(requestConfig);
        return res.data;
    }
    catch (error) {
        if (isFunction(config.onError))
            config.onError(error);
        return "Failed to send email!";
    }
}
export async function sendDemoSMS(data, config = {}) {
    const requestConfig = { url: '/users/current/sendDemoSMS', method: 'post', data };
    try {
        const res = await axios(requestConfig);
        return res.data;
    }
    catch (error) {
        if (isFunction(config.onError))
            config.onError(error);
        return "Failed to send sms!";
    }
}
export async function addUserFromFirebase(config = {}) {
    const requestConfig = { url: "/users/current/addFromFirebase", method: 'post' };
    try {
        const res = await axios(requestConfig);
        if (isFunction(config.onSuccess))
            config.onSuccess(res.data);
        return res.data;
    }
    catch (error) {
        if (isFunction(config.onError))
            config.onError(error);
        console.log("Add user from Firebase Error: ", error);
    }
}
export async function changeUserVanityName(vanityName, config = {}) {
    const requestConfig = {
        url: "/users/current/changeVanityName",
        method: 'post',
        data: { vanityName }
    };
    const data = await axiosCall(requestConfig, config);
    return data;
}
let isFetchingUserInfo = false;
export async function updateUserInfo() {
    if (!get(isCurrentUserLoaded) ||
        !get(currentUserStore) ||
        isFetchingUserInfo) {
        return;
    }
    isFetchingUserInfo = true;
    await getUser({
        onSuccess: async (info) => {
            await setUserInfo(info);
            isFetchingUserInfo = false;
        },
        onError: async (error) => {
            var _a;
            if (((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 400) {
                const userInfo = await addUserFromFirebase();
                await setUserInfo(userInfo);
                isFetchingUserInfo = false;
            }
        }
    });
}
